import { Controller } from '@hotwired/stimulus'

export default class OnboardingSignupController extends Controller {
  connect() {
    this.userInterest()
    this.languageCount()
    if ($(this.element).hasClass('sign-up-form')) {
      this.handleDisabledButton()

      this.element.addEventListener("input", () => this.toggleSubmitButton())
      this.element.addEventListener("change", () => this.toggleSubmitButton())

      this.toggleSubmitButton()
    }
  }

  handleDisabledButton() {
    this.submitButton = this.element.querySelector(".submit_button")
    this.submitButton.disabled = true
  }

  toggleSubmitButton() {
    const requiredFields = [...this.element.querySelectorAll("[required]")]

    const allFilled = requiredFields.every(field => {
      if (field.closest(".d-none")) return true

      return field.value.trim() !== ""
    })

    this.submitButton.disabled = !allFilled
  }

  get_email_field() {
    $('#email,.phoneLink').removeClass('d-none')
    $('#phone,.emailLink').addClass('d-none')
    $('label.error').html('')

    this.toggleSubmitButton()
  }

  get_phone_field() {
    $('#email,.phoneLink').addClass('d-none')
    $('#phone,.emailLink').removeClass('d-none')
    $('.email-field').val('')
    $('.phone-no').val('')
    $('.error, .error-msg').not('select, input').html(' ')

    this.toggleSubmitButton()
  }

  check_user(e) {
    e.preventDefault()
    const name = decodeURIComponent($('#user-name').val())
    $('#sign-in-link').attr('href', '#')
    if (this.timeout) clearTimeout(this.timeout)
    if (!name) {
      $('.name_error')
        .removeClass('d-none')
        .addClass('error')
        .html('Please enter phone, email or username')
      return
    }
    this.timeout = setTimeout(() => {
      fetch('/check_user?user_name=' + name, {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
          'Content-Type': 'application/json'
        }
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.user) {
            $('.name_error').addClass('d-none').removeClass('error').html('')
            $('.name-submit').removeClass('disabled')
            const src = `/password/?user_name=${encodeURIComponent(name)}`

            Turbo.visit(encodeURI(src), {
              action: 'advance',
              frame: 'modal_content'
            })
            // $('#modal_content').attr('src', src)
          } else {
            $('.name_error')
              .removeClass('d-none')
              .addClass('error')
              .html("Sorry, We couldn't find " + name + ' account.')
          }
        })
    }, 1000)
  }

  userInterest() {
    let total = document.querySelectorAll('.checkbox-pink.interest')
    const checked = Array.from(total).filter((cb) => cb.checked).length
    let errorBox = document.getElementById('content_error')
    let submitButton = document.querySelector('.interest-button')
    if (!submitButton) {
      return
    }
    if (checked >= 3) {
      errorBox.innerHTML = ''
      submitButton.disabled = false
    } else if (checked > 0 && checked < 3) {
      errorBox.innerHTML = `<p class="text-danger fs-18">Please select at least 3 interest</p>`
      submitButton.disabled = true
    } else if (checked === 0) {
      errorBox.innerHTML = ''
      submitButton.disabled = true
    }
  }

  userFollow(e) {
    $(this.element)
      .closest('.modal-body')
      .next('div')
      .find('.follow-button')
      .removeClass('disabled')
  }

  disableButton(e) {
    $('#content_error').find('p').html(' ')
    $(e.currentTarget).closest('form').find('button').prop('disabled', false)
  }

  languageCount(e) {
    if (!$(this.element).hasClass('language-form')) return;

    const checkboxes = document.querySelectorAll('.checkbox-pink.language')
    const checked = Array.from(checkboxes).filter((cb) => cb.checked).length
    let errorBox = document.getElementById('content_error')
    let submitButton = document.querySelector('.language-btn')
    if (!submitButton) {
      return
    }

    if (checked > 5) {
      e.target.checked = false
      errorBox.innerHTML = `<p class="text-danger fs-18">You can select maximum 5 languages</p>`
    } else if (checked === 0) {
      errorBox.innerHTML = ''
      submitButton.disabled = true
    } else {
      errorBox.innerHTML = ''
    }
  }

  removeError(e) {
    e.stopPropagation()
    $('.name_error').html('')
  }
}
